export default __webpack_public_path__ + "static/media/darkNftCard.0311cbf5.png";